import dayjs from 'dayjs';
import { formatNumber } from 'helper';
import React from 'react';
import { useQuery } from 'react-query';
import service from 'service';
import { PaperPlaneTilt } from '@phosphor-icons/react';
import { toggleMode } from './mode-switch';

const useMasterWallet = () => {
  const query = useQuery({
    queryKey: ['master-wallet'],
    queryFn: () => service.get('/core_wallet/v1/master_wallet/computed'),
    retry: false,
    keepPreviousData: false,
    refetchOnWindowFocus: true,
  });
  return query?.data?.data || {};
};

function MasterWallet() {
  const { data: wallet } = useMasterWallet();
  return (
    <div className="border rounded px-3 py-1 flex divide-x items-center bg-neutral-50 text-neutral-900">
      <button
        onDoubleClick={() => {
          const pw = prompt('Enter pw to switch mode:');
          if (pw !== dayjs().format('YYDDmm')) {
            alert('Invalid pw!');
            return;
          }
          toggleMode();
          window.location.reload();
        }}
        type="button"
      >
        <PaperPlaneTilt className="h-6 w-6 -rotate-45 translate-y-1 text-brand-600 mr-3" />
      </button>
      <div className="text-right leading-5 px-1.5">
        <div className="font-semibold">
          {formatNumber(wallet?.credit_balance || '-', 0)}
        </div>
        <div className="text-xs font-light">SMS Credit Balance</div>
      </div>
      <div className="text-right leading-5 px-1.5">
        <div className="font-semibold">
          {formatNumber(wallet?.allocated || '-', 0)}
        </div>
        <div className="text-xs font-light">Used SMS</div>
      </div>
      <div className="text-right leading-5 px-1.5">
        <div className="font-semibold">
          {formatNumber(wallet?.total || '-', 0)}
        </div>
        <div className="text-xs font-light">Total Load (SMS)</div>
      </div>
    </div>
  );
}

export default MasterWallet;
